var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#726fb3",
    d: "M102.78,37.23h-11.08V13.1c0-7.13-5.8-12.93-12.93-12.93h-30.54c-7.13,0-12.93,5.8-12.93,12.93v24.13h-11.08c-7.13,0-12.93,5.8-12.93,12.93v63.74c0,7.13,5.8,12.93,12.93,12.93h78.56c7.13,0,12.93-5.8,12.93-12.93v-63.74c0-7.13-5.8-12.93-12.93-12.93ZM44.48,13.1c0-2.07,1.68-3.75,3.75-3.75h30.54c2.07,0,3.75,1.68,3.75,3.75v24.13h-38.04V13.1ZM106.53,113.9c0,2.07-1.68,3.75-3.75,3.75H24.22c-2.07,0-3.75-1.68-3.75-3.75v-63.74c0-2.07,1.68-3.75,3.75-3.75h78.56c2.07,0,3.75,1.68,3.75,3.75v63.74Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#726fb3",
    d: "M71.93,76.95c0-4.65-3.78-8.44-8.44-8.44s-8.42,3.78-8.42,8.44c0,2.48,1.07,4.71,2.77,6.25v7.49c0,3,2.43,5.43,5.43,5.43h.45c3,0,5.43-2.43,5.43-5.43v-7.5c1.7-1.54,2.77-3.77,2.77-6.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassword);
export default __webpack_public_path__ + "static/media/change-password.336787245fd982c0924090dc8d49759e.svg";
export { ForwardRef as ReactComponent };